import { numeric, requiredUnless } from 'vuelidate/lib/validators';
import { QUOTA_SECTION_TITLE, SALARY_AND_SALES_PROCESS_SECTION_TITLE } from '../constants';
import { modalNames } from '@/components/partials/jobs/constants';
import * as utils from '@/components/partials/jobs/JobsInquiryForm/utils/common';
import * as csmUtils from '@/components/partials/jobs/JobsInquiryForm/utils/csmRoleUtils';
import getCsmQuotaConfig from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/configs/csmQuotaConfig';
import getCsmQuotaFormConfig from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/configs/csmQuotaFormConfig';
import getCsmSalaryConfig from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/configs/csmSalaryConfig';
import csmSalaryFormConfig from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/configs/csmSalaryFormConfig';
import type {
  JobsProfileConfig,
  JobsSectionModels,
} from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';
import { JobsInquiryCsmQuota } from '@/types/graphql';

export default (payload: JobsSectionModels): JobsProfileConfig => {
  return [
    {
      title: QUOTA_SECTION_TITLE,
      fields: [...getCsmQuotaConfig(payload)],
      editModalConfig: {
        name: modalNames.JOBS_EDIT_QUOTA,
        title: QUOTA_SECTION_TITLE,
        fields: [...getCsmQuotaFormConfig(payload)],
        getValidation: ({ form, hasAdminPrivilege }) => {
          return {
            csmQuotaTypeMain: {
              required: () => (hasAdminPrivilege ? true : Boolean(form.csmQuotaTypeMain || form.csmQuotaTypeOther)),
            },
            csmQuotaMetricMain: {
              required: () => {
                if (hasAdminPrivilege) return true;
                if (form.csmQuotaTypeMain === JobsInquiryCsmQuota.CsmNoQuota) return true;

                return Boolean(form.csmQuotaMetricMain?.length || form.csmQuotaMetricOther);
              },
            },
            csmQuotaPeriodMain: {
              required: () => {
                if (hasAdminPrivilege) return true;
                if (form.csmQuotaTypeMain === JobsInquiryCsmQuota.CsmNoQuota) return true;

                return Boolean(form.csmQuotaPeriodMain || form.csmQuotaPeriodOther);
              },
            },
            quotaAttainmentPerPeriod: { numeric },
            salesCycleLength: {
              required: requiredUnless(() => hasAdminPrivilege),
            },
          };
        },
        generateForm: utils.generateForm,
        prepareFormForUpsert: utils.prepareFormForUpsertForQuotaAndDealsModal,
      },
    },
    {
      title: SALARY_AND_SALES_PROCESS_SECTION_TITLE,
      fields: [...getCsmSalaryConfig(payload)],
      editModalConfig: {
        name: modalNames.JOBS_EDIT_SALARY,
        title: SALARY_AND_SALES_PROCESS_SECTION_TITLE,
        fields: [...csmSalaryFormConfig(payload)],
        getValidation: csmUtils.validateEditSalarySectionModalForm,
        prepareFormForUpsert: utils.prepareFormForUpsert,
      },
    },
  ];
};
